import $ from "jquery";
import BD_Component from "../core/bd-component";
import compile from "../utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { getRoomStatus, getFinalTeamAnswers } from "@bd-stores/game-progress";
import CompletionPopup from "@bd-utils/completion-popup";
import {
    saveFinalRoomAnswers,
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    getRoomAnswers,
} from "@bd-core/firebase-actions";

export class RoomInputCode extends BD_Component {
    constructor() {
        super();

        this.id = "input_code";
        this.templateID = "input_code-template";

        this.elms = {
            backButton: ".app__back",
            appTools: ".app__tools",
            logo: ".app__brand",
            timer: ".js-timer",
            check: ".js-content-wrapper",
            checkBtn: ".js-check",
            mapScreen: ".js-map",
            map: ".js-past-room-map",
            inputAnswer: ".js-input-answer",
        };

        this._events = this.getEvents();

        this.completionPopup = new CompletionPopup();
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.checkBtn,
                handler: this.onCheck,
            },
            {
                event: "click",
                selector: elms.map,
                handler: this.zoomInMap,
            },
            {
                event: "keypress",
                selector: elms.inputAnswer,
                handler: this.inputAnswer,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
    }

    getModifiedData() {
        const modified = { ...this._data };

        const defaultImageBg = `${CONFIG.themeURL}/assets/images/bg-wood.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const hintHotspots = this._data.hotspots.filter(
            (hotspot) => hotspot["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";
        const _hints = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const modifiedData = {
            ...modified,
            hints: _hints,
            image_bg: _image_bg,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        let template = compile(htmlTemplate, modifiedData);

        $(".app").html(template);
        if (isForcedOpenChallenge) {
            // this.onForceOppenChallenge();
        }
    }

    onForceOppenChallenge() {
        const elms = this.elms.questionPopup;
        const closeButton = this.elms.closeButtonPopup;
        const backButton = this.elms.backButton;

        const blur = $(".app-blur");

        blur.addClass("is-blurred");

        $(elms).addClass("is-open");
        $(closeButton).addClass("hidden");
        $(backButton).addClass("up-front");
    }

    setGameState() {
        const elms = this.elms;
        const roomID = this.roomId;
        const thisRoomStatus = getRoomStatus(roomID);
        const roomAnswers = getFinalTeamAnswers(roomID);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        getRoomAnswers(roomID).then((data) => {
            this.updateUserChoicesList(data);
        });

        if (roomAnswers) {
            const answers =
                typeof roomAnswers === "string"
                    ? [...roomAnswers]
                    : roomAnswers;

            if (Object.keys(answers).length == 0) return;

            $.each(answers, function (index, value) {
                $(elms.inputAnswer).eq(index).val(value);
            });
        }

        if (thisRoomStatus == "is-status-completed") {
            $(elms.checkBtn)
                .addClass("is-completed")
                .prop("disabled", true)
                .parent()
                .addClass("is-completed");

            $(elms.check).addClass("is-completed").removeClass("is-wrong");

            $(elms.inputAnswer).prop("readonly", true);
            $(".app__page").addClass("is-room-completed");

            /* Show completion popup */
            this.completionPopup.show(roomID, false, roomAnswers);
        }
    }

    // ============================== CUSTOM FUNCTION

    /**
     * Decide whether to disabled or enabled check button
     */
    toggleCheckButton() {
        const elms = this.elms;
        const $answers = $(elms.inputAnswer);
        const $checkBtn = $(elms.checkBtn);
        let isAllFilled = true;

        $.each($answers, function (index, answer) {
            const $answer = $(answer);
            const value = String($answer.val());

            if (value.trim() == "") {
                isAllFilled = false;
                return false;
            }
        });

        return $checkBtn
            .prop("disabled", !isAllFilled)
            .toggleClass("valid", isAllFilled);
    }

    onCheck(e, el) {
        const elms = this.elms;
        const $el = $(el);
        const $answers = $(elms.inputAnswer);

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        $el.parent().removeClass("is-checked");
        $el.addClass("is-loading").prop("disabled", true);

        const roomId = this.roomId;
        const roomAnswers = getRoomAnswerById(roomId);
        let roomStatus = "is-status-started";
        let isCorrect = false;
        let answerData = "";

        $(elms.inputAnswer).each(function () {
            const $item = $(this);
            const answer = $item.val();

            if (answer !== "") {
                answerData += "" + answer;
            }
        });

        if (roomAnswers.code == answerData) isCorrect = true;

        if (isCorrect) {
            roomStatus = "is-status-completed";

            const onSuccessUpdate = () => {
                $el.removeClass("is-loading");
            };

            const onErrorUpdate = () => {};

            saveFinalRoomAnswers(roomId, answerData)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);
        } else {
            $el.addClass("is-checked")
                .removeClass("is-loading")
                .removeAttr("disabled")
                .toggleClass("is-completed", isCorrect);

            $(elms.check)
                .toggleClass("is-completed", isCorrect)
                .toggleClass("is-wrong", !isCorrect);

            $answers.prop("readonly", isCorrect);
        }

        this.updateUserAnswer(answerData);

        maybeUpdateRoomStatus(roomId, roomStatus);
    }

    zoomInMap() {
        const elms = this.elms;
        const isZoomed = $(elms.mapScreen).hasClass("is-zoomed");
        if (isZoomed) return this.zoomOutMap();

        $(elms.mapScreen).addClass("is-zoomed");
        $(elms.backButton).removeClass("js-change-page");
        $(elms.backButton).addClass("is-temporary-hidden");
        $(elms.logo).addClass("is-temporary-hidden");
        $(elms.timer).addClass("is-temporary-hidden");
        $(elms.check).addClass("is-temporary-hidden");
        $(elms.appTools).addClass("is-temporary-hidden");
    }

    zoomOutMap() {
        const elms = this.elms;

        $(elms.mapScreen).removeClass("is-zoomed");
        $(elms.backButton).addClass("js-change-page");
        $(elms.backButton).removeClass("is-temporary-hidden");
        $(elms.logo).removeClass("is-temporary-hidden");
        $(elms.timer).removeClass("is-temporary-hidden");
        $(elms.check).removeClass("is-temporary-hidden");
        $(elms.appTools).removeClass("is-temporary-hidden");
    }

    inputAnswer(e, el) {
        e.preventDefault();

        const $el = $(el);
        const elms = this.elms;
        const isCompleted = $(elms.check).hasClass("is-completed");

        if (isCompleted) {
            return false;
        }

        const regex = new RegExp("^[a-zA-Z0-9]+$");
        const key = String.fromCharCode(!e.keyCode ? e.which : e.keyCode);

        if (!regex.test(key)) {
            this.toggleCheckButton();
            return false;
        }

        const value = String($el.val(e.key));

        const $current = $el.parent();
        const $nextInput = $current.next();

        if (value.trim() !== "" && $nextInput.length) {
            $nextInput.find("input").trigger("focus");
        }

        $(elms.check).removeClass("is-wrong");
        this.toggleCheckButton();
    }

    updateUserAnswer(answerData) {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        updateRoomAnswer(roomId, {
            [currentPlayerId]: {
                user_id: currentPlayerId,
                choice: answerData,
            },
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const users = onlinePlayers.map((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "string") {
                    return;
                }

                const user = {
                    ...player,
                    answer: thisPlayerAnswer,
                };

                return user;
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }
}
